import React from 'react';
import {
  Button,
  useColorMode,
  useColorStyle,
  Box,
  Flex,
  Space,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  Text,
  ModalOverlay,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

const DelOrgModal = React.memo(
  (props: { isVisible: boolean; onClose: () => void; onDel: () => void }) => {
    const { isVisible, onClose, onDel } = props;
    const [colorMode] = useColorMode();
    const [colorStyle] = useColorStyle({ colorMode });
    const { t } = useTranslation();
    return (
      <Modal
        ensureFocus={true}
        autoFocus={false}
        closeOnEsc={true}
        closeOnOutsideClick={false}
        isClosable={true}
        isOpen={isVisible}
        onClose={onClose}
        size="sm"
      >
        <ModalOverlay opacity={0.9} />
        <ModalContent backgroundColor={colorStyle.background.secondary}>
          <ModalBody ml="24px" mt="16px" mb="16px">
            <Box>
              <Flex mt="22px" alignItems="flex-start">
                <Text>{t('administration.orgDel.title')}</Text>
              </Flex>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="primary" minWidth="20x" onClick={onDel}>
              {t('common.button.ok')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={onClose}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);

export default DelOrgModal;
